const isDevelopment = process.env.NODE_ENV === 'development';

export const appId = 'wx76ea4dd3d0f37710';
export const apiUrl = isDevelopment
    ? 'https://api.ruisikd.com/'
    : 'https://api.ruisikd.com/';
    // ? 'https://jyf-wxruisi.f.wmeimob.com/'
    // : 'https://jyf-wxruisi.f.wmeimob.com/';

// export const redirectUri = 'http://liuguiqiang-huaxia.f.wmeimob.com';

// export const loginUrl = '/pages/login/index';
